if (!customElements.get('speakon-agent-hero')) {
  customElements.define('speakon-agent-hero', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const background = this.querySelector('.speakon-agent-hero__background-video');
      const playback = this.querySelector('[data-toggle-background]');
      const dialog = this.querySelector('dialog');
      let film = dialog?.querySelector('video');
      const embed = dialog?.querySelector('[data-film-embed]');
      const error = dialog?.querySelector('[data-film-error]');
      const opener = this.querySelector('[data-open-film]');

      if (dialog && (film || embed) && opener) {
        opener.disabled = false;
        opener.addEventListener('click', () => {
          if (dialog.open) return;
          if (embed) {
            const source = this.filmSource(dialog.dataset.filmUrl);
            error.hidden = Boolean(source);
            if (source) {
              const media = document.createElement(source.format === 'youtube' ? 'iframe' : 'video');
              media.src = source.src;
              if (source.format === 'youtube') {
                media.title = dialog.getAttribute('aria-label');
                media.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
                media.allowFullscreen = true;
              } else {
                media.className = 'speakon-agent-film__video';
                media.controls = true;
                media.playsInline = true;
                film = media;
              }
              embed.replaceChildren(media);
            }
          }
          dialog.showModal();
          film?.play().catch(() => { /* Native controls allow playback if autoplay is blocked. */ });
        }, options);
        this.querySelector('[data-close-film]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', event => {
          if (event.target === dialog) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          if (film) {
            film.pause();
            film.currentTime = 0;
          }
          embed?.replaceChildren();
          if (embed) film = null;
          if (opener.isConnected) opener.focus();
        }, options);
      }

      if (!background) return;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let pausedByUser = false;
      let inView = false;
      const update = () => {
        if (playback) {
          playback.hidden = reducedMotion.matches;
          playback.querySelector('[data-pause-label]').hidden = pausedByUser;
          playback.querySelector('[data-play-label]').hidden = !pausedByUser;
        }
        if (reducedMotion.matches || pausedByUser || !inView || dialog?.open) background.pause();
        else background.play().catch(() => { if (playback) playback.hidden = true; });
      };
      background.addEventListener('playing', () => this.setAttribute('data-video-ready', ''), options);
      playback?.addEventListener('click', () => { pausedByUser = !pausedByUser; update(); }, options);
      reducedMotion.addEventListener('change', update, options);
      dialog?.addEventListener('close', update, options);
      opener?.addEventListener('click', update, options);
      this.observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        update();
      });
      this.observer.observe(this);
    }

    filmSource(link) {
      let url;
      try { url = new URL(link, location.href); } catch { return null; }
      if (url.protocol !== 'https:') return null;
      const parts = url.pathname.split('/').filter(Boolean);
      if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be'].includes(url.hostname)) {
        const id = url.hostname === 'youtu.be' ? parts[0] :
          url.pathname === '/watch' ? url.searchParams.get('v') :
          ['embed', 'shorts'].includes(parts[0]) ? parts[1] : null;
        if (/^[\w-]{11}$/.test(id || '')) return { format: 'youtube', src: `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1` };
      }
      if (/\.(mp4|webm|m4v|mov)$/i.test(url.pathname)) return { format: 'video', src: url.href };
      return null;
    }

    disconnectedCallback() {
      this.querySelector('dialog[open]')?.close();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
